import { ServicePage } from '../ServicePage';

export default function Private() {
  return (
    <ServicePage
      categoryKey="private"
      heroImage="https://images.unsplash.com/photo-1530366242091-52981c0514ad?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1800"
      overline="Hizmetlerimiz"
      headline="Özel Davetler"
      headlineAccent="Kişisel. İnce. Anlamlı."
      intro="Bazı anlar yalnızca size aittir. Doğum günlerinden yıl dönümlerine, aile kutlamalarından butik özel partilere; İMER her özel anınızı kişisel bir lüks deneyimine dönüştürür."
      inclusions={[
        { title: 'Kişisel Konsept Tasarımı', desc: 'Size özel bir atmosfer ve estetik kurgu' },
        { title: 'Mekân & Dekorasyon', desc: 'Özel mekân arayışı ve butik süsleme tasarımı' },
        { title: 'Aydınlatma & Ambians', desc: 'Duygusal atmosferi tamamlayan özel ışık düzeni' },
        { title: 'Catering & İkram', desc: 'Butik yemek seçenekleri ve özel menü planlaması' },
        { title: 'Müzik & Eğlence Programı', desc: 'Canlı müzik, DJ veya özel eğlence programı' },
        { title: 'Kişisel Detaylar', desc: 'Sürpriz organizasyonu, özel hediye ve anı köşesi tasarımı' },
        { title: 'Fotoğraf & Çekim', desc: 'Anlarınızı ölümsüzleştirecek profesyonel fotoğrafçı koordinasyonu' },
        { title: 'Konuk Yönetimi', desc: 'Davetli listesi ve misafir koordinasyonu' },
      ]}
      processSteps={[
        { num: '01', title: 'Tanışma', desc: 'Sizi ve neyi kutladığınızı dinliyoruz. Değerlerinizi, beğenilerinizi ve hayallerinizi anlıyoruz.' },
        { num: '02', title: 'Konsept', desc: 'Size özel bir atmosfer, renk paleti ve deneyim konsepti tasarlıyoruz.' },
        { num: '03', title: 'Planlama', desc: 'Mekan, tedarikçi ve tüm lojistiği eksiksiz organize ediyoruz.' },
        { num: '04', title: 'Hazırlık', desc: 'Etkinlik öncesi tüm kurulum ve son kontrolleri gerçekleştiriyoruz.' },
        { num: '05', title: 'Özel Gün', desc: 'Siz sadece anın tadını çıkarın; her detay için biz varız.' },
      ]}
      signatureDetails={{
        title: 'Her An, Bir Anıya Dönüşür',
        body: 'Özel davetlerde büyük prodüksiyon değil, doğru detay önemlidir. İMER, her küçük dokunuşun fark yaratacağı unutulmaz anlar yaratmak için titiz bir özen gösterir.',
        list: [
          'Doğum günü organizasyonları',
          'Yıl dönümü kutlamaları',
          'Aile toplantıları & özel davetler',
          '50. yıl gibi özel dönüm noktaları',
          'Butik cocktail partileri',
        ],
        image: 'https://images.unsplash.com/photo-1648234056158-6f3304f2115a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
      }}
      faqItems={[
        { q: 'Küçük ölçekli özel etkinlikler de düzenliyorsunuz?', a: '10 kişilik butik özel davetlerden 300 kişilik büyük kutlamalara kadar tüm ölçeklerde hizmet veriyoruz.' },
        { q: 'Sürpriz organizasyonu yapıyor musunuz?', a: 'Evet, sürpriz organizasyonları uzmanlık alanlarımız arasındadır. Koordinasyonun gizli tutulması için özel süreçlerimiz mevcuttur.' },
      ]}
    />
  );
}
